function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M45.5 28.9h-1v15.6h-41V28.9h-3v18.6h47V28.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24 .5L8.8 15.7h9.6v17.6h11.2V15.7h9.6z"
}));

function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 60"
  }, props), _ref);
}

export default SvgUpload;